import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { Header } from "../../Header/Header"
import { SideBar } from "../../SideBar/SideBar"
import { Footer } from "../../../Footer/Footer"
import ViewPopup from "../../CommonPopUp/ViewPopup"
import DocumentUploadPopup from "./DocumentUploadPopup"
import ConfirmationPopup from "../../CommonPopUp/ConfirmationPopup"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../Helper/Context/context"
import { MCRuralReceivedGrievanceAcknowledgePostAPI, ReceivedResolvedGrievanceGetAPI } from "../../../../Helper/Redux/DirectorDashboardSlice/ReceivedResolvedGrievanceSlice"
import { DistrictDDL } from "../../../../Components/CommonDDL/DistrictDDL"
import { GenderDDL } from "../../../../Components/CommonDDL/GenderDDL"
import { Pegination } from "../../../../Components/Pagination/Pagination"
import moment from "moment"
import { Loading } from "../../../../Helper/Loader/LogoLoader"
import { t } from "i18next"

export const DirectorEscalatedMunicipalCorporationgrid = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails

    const [ShowConfirmationPopup, setShowConfirmationPopup] = useState(false)
    const [ShowViewPopup, setShowViewPopup] = useState(false)

    const [DocumentUploadViewPopup, setDocumentUploadViewPopup] = useState(false)
    const [searchparams] = useSearchParams()
    const screenname = searchparams.get('screenname')
    const Flag = searchparams.get('Flag')
    const DDLFinantialYearID = searchparams.get('DDLFinantialYearID')
    const DDLMonthID = searchparams.get('DDLMonthID')
    const screenheading = searchparams.get('screenheading')
    const screensubheading = searchparams.get('screensubheading')
    const MunicipalCarporationID = searchparams.get('MunicipalCarporationID')

    const [IsSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)

    // Pagination
    const [IsClear, setIsClear] = useState(false)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [isopen, setIsOpen] = useState(false);

    const [ModalData, setModalData] = useState({
        Flag: '',
        RowData: ''
    })
    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })
    const [DistrictDDLID, setDistrictDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [GrievanceTypeID, setGrievanceTypeID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [TalukaDDLID, setTalukaDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })

    const handleShowView = (rowData, t_GrievanceRegistrationID) => {
        setShowViewPopup(!ShowViewPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',
            t_GrievanceRegistrationID: t_GrievanceRegistrationID,

        })
    }

    const handleShowConfirmation = (rowData) => {
        setShowConfirmationPopup(!ShowConfirmationPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',


        })
    }

    const handleDocumentUploadView = (rowData, t_GrievanceRegistrationID) => {
        setDocumentUploadViewPopup(!DocumentUploadViewPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',
            t_GrievanceRegistrationID: t_GrievanceRegistrationID
        })
    }

    const handleSearch = () => {
        setIsSearch(!IsSearch)
    }

    const handleClear = () => {
        setIsClear(!IsClear)

        setDistrictDDLID({
            ...DistrictDDLID,
            ID: 0,
            Label: 'Select...'
        })
        setGrievanceTypeID({
            ...GrievanceTypeID,
            ID: 0,
            Label: 'Select...'
        })

    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: DDLFinantialYearID,
            M_MonthID: DDLMonthID,
            GrievanceDate: '',
            // M_IndicatorGrievanceAreaID: IndicatorGrievanceAreaID,
            M_IndicatorGrievanceAreaID: 0,
            M_DistrictID: DistrictDDLID.ID,
            M_TalukaID: 0,
            M_IndicatorGrievanceTypeID: GrievanceTypeID.ID,
            M_StatusID: 0,
            ShowBy: "All",
            Flag: Flag,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
        }
        { Language.Label != null && dispatch(ReceivedResolvedGrievanceGetAPI({ data })) }
    }, [Language.Label, DDLFinantialYearID, DDLMonthID, IsClear, IsSearch, IsPost, To, DistrictDDLID.ID, GrievanceTypeID.ID])

    const { TableData, isLoading } = useSelector(state => state.ReceivedResolvedGrievanceGetData)

    const handleAcknowledge = () => {
        const data = {
            T_GrievanceRegistrationID: ModalData.RowData.t_GrievanceRegistrationID,
            Remark: '',
            Flag: 'StateNodal_ACK',
            token: token,
            M_UserID: UserID,
            handleShowConfirmation: handleShowConfirmation,
            handleIsPost: handleIsPost,
            screenname: screenname

        }
        dispatch(MCRuralReceivedGrievanceAcknowledgePostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.MCRuralReceivedGrievanceAcknowledgePostData)

    return (
        <>
            {isLoading && <Loading />}
            {isPostLoading && <Loading />}
            <Header Language={Language}
                setLanguage={setLanguage} />
            {/* <SideBar active="MainDashboard" /> */}
            <div id="wrapper" className="d-flex justify-content-center">
                <SideBar active="DirectorDashboard" />
                <div className="main-content user_dashboard d-flex flex-column body-scroll px-0 px-lg-3" id='content' >

                    <div className="row px-2 pt-3">
                        <div className="col-12">
                            <h6 className="text-black fw-bold h7 pt-0 pb-2">
                                {screenheading && screenheading == 'Escalated Grievance' ?
                                    t('DirectorDashboard.EscalatedGrievances') : ''}
                            </h6>
                        </div>
                    </div>

                    <div className="container-fluid px-3 shadow bg-white" style={{ border: '4px solid #dddcdc' }}>
                        <>
                            <div className="row pt-3">
                                <div className="col-12">
                                    <h6 className="text-black fw-bold h7 pt-0 pb-2">
                                        {screensubheading && screensubheading == 'Municipal Corporation' ?
                                            t('DirectorDashboard.MunicipalCorporation') : ''}
                                        -
                                        <span className="text-primary">
                                            {screenname && screenname == 'Received' ?
                                                t('DirectorDashboard.ReceivedGrievance') :
                                                screenname && screenname == 'Acknowledge' ?
                                                    t('DirectorDashboard.AcknowledgeGrievance') :
                                                    screenname && screenname == 'Resolved' ?
                                                        t('DirectorDashboard.ReslovedGrievance') :
                                                        t('DirectorDashboard.PendingGrievance')}
                                        </span>
                                    </h6>
                                </div>
                            </div>

                            <div className="row py-3 py-lg-4">
                                <div className="col-12 col-lg-3 py-2 py-lg-0">
                                    <span className="all_lable_text">
                                        {t('DirectorDashboard.DistrictName')}
                                    </span>
                                    <DistrictDDL
                                        DistrictDDLID={DistrictDDLID}
                                        setDistrictDDLID={setDistrictDDLID}
                                        Language={Language}
                                        M_IndicatorGrievanceAreaID={MunicipalCarporationID}
                                        UserID={UserID}
                                    />
                                </div>

                                <div className="col-12 col-lg-3 py-2 py-lg-0">
                                    <span className="all_lable_text">
                                        {t('DirectorDashboard.GrievanceType')}
                                    </span>
                                    <GenderDDL
                                        GenderDDLID={GrievanceTypeID}
                                        setGenderDDLID={setGrievanceTypeID}
                                        Language={Language}
                                        GroupID='3'
                                        UserID={UserID}
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 pt-2 mt-3  ">
                                    <button type="button" className="btn btn-outline-dark border-2 mx-2 button-size"
                                        onClick={handleSearch}
                                    >
                                        Search</button>

                                    <button type="button" className="btn btn-danger border-2 button-size"
                                        onClick={handleClear}
                                    >Clear</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="table-responsive p-0">
                                        <table className="table table-bordered w-100">
                                            <thead>
                                                <tr className="bg-dark">
                                                    <th className="">{t('GridHeading.Sr_No')}</th>
                                                    <th className="">{t('GridHeading.ComplaintID')}</th>
                                                    {
                                                        screenname == 'Received' &&
                                                        <th className=""> {t('DirectorDashboard.EscalatedGrievanceDate')}</th>


                                                    }
                                                    {
                                                        screenname == 'Acknowledge' &&
                                                        <th className="">{t('DirectorDashboard.AcknowledgeDate')}
                                                        </th>

                                                    }

                                                    {
                                                        screenname == 'Resolved' &&
                                                        <th className="">{t('DirectorDashboard.ResolvedDate')}
                                                        </th>

                                                    }

                                                    {
                                                        screenname == 'Pending' &&
                                                        <th className=""> {t('DirectorDashboard.EscalatedGrievanceDate')}</th>


                                                    }

                                                    <th className=" ps-2">{t('DirectorDashboard.MunicipalCorporation')}</th>
                                                    <th className=" ps-2">{t('DirectorDashboard.DistrictName')}</th>
                                                    <th className=" ps-2">{t('DirectorDashboard.GrievanceType')}</th>
                                                    <th className=" ps-2 text-center">{t('DirectorDashboard.GrievanceDetails')}</th>

                                                    {
                                                        (screenname == 'Received' && RoleID == 3) &&
                                                        <th className=" ps-2 text-center">{t('DirectorDashboard.Action')}</th>
                                                    }

                                                    {
                                                        (screenname == 'Acknowledge' && RoleID == 3) &&
                                                        <th className=" ps-2 text-center">{t('DirectorDashboard.Action')}</th>
                                                    }

                                                    {/* {
                                                        (screenname == 'Pending' && RoleID == 3) &&
                                                        <th className=" ps-2 text-center">Action</th>
                                                    } */}
                                                    {
                                                        (screenname == 'Resolved' && RoleID == 3) &&
                                                        <th className=" ps-2 text-center">{t('DirectorDashboard.StateNodalUploadReport')}</th>
                                                    }

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    TableData && TableData.length > 0 ?
                                                        TableData.map((i, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="w-7">{i?.rowNum}</td>
                                                                    <td className="w-7">{i.t_GrievanceRegistrationID ? i.t_GrievanceRegistrationID : '-'}</td>
                                                                    {
                                                                        screenname == 'Received' &&
                                                                        <td>{i.escalatedDate ? moment(i.escalatedDate).format('DD-MM-YYYY') : '-'}</td>

                                                                    }

                                                                    {
                                                                        screenname == 'Acknowledge' &&
                                                                        <td>{i.acknowledgeDate ? moment(i.acknowledgeDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    }

                                                                    {
                                                                        screenname == 'Resolved' &&
                                                                        <td>{i.actionReportDateStateNodal ? moment(i.actionReportDateStateNodal).format('DD-MM-YYYY') : '-'}</td>
                                                                    }

                                                                    {
                                                                        screenname == 'Pending' &&
                                                                        <td>{i.escalatedDate ? moment(i.escalatedDate).format('DD-MM-YYYY') : '-'}</td>

                                                                    }
                                                                    <td>{i.districtName ? i.districtName : '-'}</td>
                                                                    <td>-</td>
                                                                    <td>{i.m_IndicatorGrievanceType ? i.m_IndicatorGrievanceType : '-'}</td>
                                                                    <td className="text-center w-20">
                                                                        <span className="view_button"
                                                                            data-bs-toggle="tooltip" data-bs-placement="bottom"
                                                                            title="View Grievance Details"
                                                                            onClick={() => handleShowView(i, i.t_GrievanceRegistrationID)}>
                                                                            <i class="fa-solid fa-eye"></i>
                                                                        </span>
                                                                    </td>
                                                                    {
                                                                        (screenname == 'Received' && RoleID == 3) &&
                                                                        <td className="text-center w-20">
                                                                            {
                                                                                (i.acK_Date == null) ?

                                                                                    <span className="Acknowledge_button"
                                                                                        onClick={() => handleShowConfirmation(i)}
                                                                                    >Acknowledge </span>
                                                                                    :
                                                                                    <span> - </span>
                                                                            }
                                                                        </td>

                                                                    }

                                                                    {
                                                                        (screenname == 'Acknowledge' && RoleID == 3) &&

                                                                        <td className="text-center w-20">
                                                                            <span className="Acknowledge_button"
                                                                                onClick={() => handleDocumentUploadView(i, i.t_GrievanceRegistrationID)}
                                                                            >Add</span>
                                                                        </td>


                                                                    }

                                                                    {/* {
                                                                        (screenname == 'Pending' && RoleID == 3) &&

                                                                        <td className="text-center w-20">
                                                                            <span className="Acknowledge_button"
                                                                                onClick={() => handleDocumentUploadView(i, i.t_GrievanceRegistrationID)}
                                                                            >Add</span>
                                                                        </td>

                                                                    } */}
                                                                    {
                                                                        (screenname == 'Resolved' && RoleID == 3) &&
                                                                        <td className="text-center w-20">
                                                                            <span className="view_button"

                                                                                // title="View Grievance Details"
                                                                                onClick={() => window.open(i.actionReportStateNodal)}
                                                                            >
                                                                                <i class="fa-solid fa-file"></i>
                                                                            </span>
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            )
                                                        })
                                                        : <>Record Not Found</>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {TableData && TableData.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={TableData[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                            IsClear={IsClear}
                                        />
                                    }
                                </div>
                            </div>
                        </>
                    </div>
                    <Footer />
                </div>
            </div >

            {
                ShowViewPopup &&
                <ViewPopup
                    handleShowView={handleShowView}
                    Title='View'
                    ModalData={ModalData}
                // handleDeleteData={handleDeleteData}
                />
            }
            {
                ShowConfirmationPopup &&
                <ConfirmationPopup
                    handleShowConfirmation={handleShowConfirmation}
                    Title='Acknowledge'
                    message='Are you sure! Do you want to Acknowledge ?'
                    // message={`Are you sure! Do you want to ${ModalData.heading} ?`}
                    handleAcknowledge={handleAcknowledge}
                // Remark={Remark}
                // setRemark={setRemark}
                />
            }

            {
                DocumentUploadViewPopup &&
                <DocumentUploadPopup
                    handleDocumentUploadView={handleDocumentUploadView}
                    Title='Add'
                    ModalData={ModalData}
                    TableData={TableData}
                    handleIsPost={handleIsPost}
                />
            }
            {/* <Footer /> */}
        </>
    )
}